var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_tabel_active") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "final",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_tabel_active",
    transform: "translate(-4.000000, -4.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-30",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(4.000000, 4.000000)",
    stroke: "#1557bf"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 0.5,
    y: 0.5,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.58333333,2.5 L21.4166667,2.5",
    id: "Line-Copy",
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(4.000000, 12.000000)",
    stroke: "#1557bf"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    x: 0.5,
    y: 0.5,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.58333333,2.5 L21.4166667,2.5",
    id: "Line-Copy-2",
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy-5",
    transform: "translate(4.000000, 21.000000)",
    stroke: "#1557bf"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    x: 0.5,
    y: 0.5,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.58333333,2.5 L21.4166667,2.5",
    id: "Line-Copy-2",
    strokeLinecap: "square"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableActive);
export default __webpack_public_path__ + "static/media/table-active.7db910597cee978c609e802c5cc07147.svg";
export { ForwardRef as ReactComponent };